import * as filterKeyMap from '@/pages/intelligence/components/Filter/FilterBase/_config';
import {
  getCommonTimeFilterValues,
  topchartFilterUndefinedValues,
} from '@intelligence/pages/TopCharts/_config/topchartFilterCfg';
import { IMarketProfileMobilePageData } from '@intelligence/services/marketProfile';
import { toDateTypeLy } from '@intelligence/utils/common';
import { ALL_METRICS } from '../constants';

// marketProfile filter 桥接页面参数
export const handleFilterToApiParams = (
  fetchParams: IMarketProfileMobilePageData,
  filterValue: any = {},
  apiValue: any = {},
) => {
  if (JSON.stringify(filterValue) === '{}') {
    return fetchParams;
  }
  // console.log('handlePCConsoleTopChartsFilterParamsToApi-fetchParams', fetchParams);
  // console.log('handlePCConsoleTopChartsFilterParamsToApi-filterValue', filterValue);

  const startDate = getCommonTimeFilterValues(filterValue, 0);
  const endDate = getCommonTimeFilterValues(filterValue, 1);
  // const metricRange = handleMetricRangeFilter(filterValue);
  const source = filterValue[filterKeyMap.DATASOURCESIM]?.value;
  const regionsArr = filterValue[filterKeyMap.REGION]?.markets;
  const regions = regionsArr?.includes('global') ? [] : regionsArr;
  const sourceMetrics = { [source]: ALL_METRICS };

  const filterForm: IMarketProfileMobilePageData = {
    ...fetchParams,
    genres: filterValue[filterKeyMap.DIGITAL_SEGMENT_MULTIPLE]?.value,
    source_metrics: sourceMetrics,
    granularity: toDateTypeLy[filterValue[filterKeyMap.RANGE_TIME]?.type],
    start_date: fetchParams?.start_date ? startDate : undefined,
    end_date: fetchParams?.end_date ? endDate : undefined,
    regions,

    // company: filterValue[filterKeyMap.ALL_COMPANYS]?.value || [],
    // filter_ids: filterValue[filterKeyMap.ALL_Games]?.value || [],
    // steam_tag: filterValue[filterKeyMap.STEAM_TAGS]?.value,
    // game_mode: filterValue[filterKeyMap.GAME_MODE]?.value,
    // device: filterValue[filterKeyMap.METRICTABLE_DEVICE]?.value,
    // iegg_genre_req: apiValue[filterKeyMap.GENRETOR]?.iegg_genre_req || [],
    // start_release_time: apiValue[filterKeyMap.RELEASE_TIME]?.start_release_time || '',
    // end_release_time: apiValue[filterKeyMap.RELEASE_TIME]?.end_release_time || '',
    // ...metricRange,
    // ...genreParamsValue,
  };

  // console.log('handleMarketProfile FilterParamsToApi', {
  //   fetchParams,
  //   filterValue,
  //   transForm: topchartFilterUndefinedValues(filterForm),
  //   apiValue,
  //   filterForm,
  // });

  // return topchartFilterUndefinedValues(filterForm);
  return filterForm;
};
